import { useNavigate } from "react-router-dom";
import { Icon } from "../icons/icon";

export const BackButton = ({
  text,
  onClick,
  className,
  backIcon = "",
}: {
  text: string;
  onClick?: () => void;
  className?: string;
  backIcon?: string;
}) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          navigate(-1);
        }
      }}
      className={`
      group
      w-fit
      flex items-center 
      gap-2
      hover:cursor-pointer
      text-base
      text-pry-dark-green-300
      transition-all
      ${className}
      `}
    >
      <Icon
        svg={backIcon ? backIcon : "left-arrow"}
        width={24}
        height={24}
        className="group-hover:scale-110 group-hover:text-pry-green-200 transition-all size-[14px] md:size-[24px]"
      />

      <p className="font-medium text-base group-hover:scale-95 transition-all">
        {text}
      </p>
    </button>
  );
};
